import(/* webpackMode: "eager" */ "/Users/viper/code/sms/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/viper/code/sms/src/components/Breadcrumbs/index.tsx");
